// frontend/src/utils/routeMatch.js
//
// The one route-prefix matcher for the app's install affordances: the top
// install banner (InstallPrompt, over its app-area allowlist) and the
// awareness snackbar (PwaAwarenessSnackbar, narrowed to the dashboard) both
// use it, so neither keeps a second copy of the segment-boundary rule. It lives
// here rather than in either component so importing it never pulls a
// component (and its service imports) into the caller's module graph.

/**
 * Prefix match with a segment boundary, so `/website` (the builder, signed-in)
 * matches `/website` and `/website/...` while `/business-website` (the public
 * landing page) and `/websites` do not.
 *
 * Total: a non-string pathname (no location yet) is simply "no match".
 *
 * @param {string} pathname e.g. `window.location.pathname`
 * @param {string} prefix e.g. "/dashboard" - a leading slash, no trailing one
 * @returns {boolean}
 */
export const matchesRoutePrefix = (pathname, prefix) =>
  typeof pathname === 'string' &&
  (pathname === prefix || pathname.startsWith(`${prefix}/`));
